import { useUserStore } from '~/stores/user';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const noAuthRouteNames = [
    'login',
    'forgot-password',
    'reset-password',
    'complete-account',
    'schedule-appointment',
    'index',
  ];
  if (noAuthRouteNames.some((route) => route === to.name)) {
    return;
  }

  const userStore = useUserStore();

  if (!userStore.user) {
    await userStore.getUser();
  }

  // Page Permissions
  if (userStore.user && to.meta.permittedRoles) {
    const roles = to.meta.permittedRoles as number[];
    if (!roles.some((role) => role === userStore.user!.role)) {
      return navigateTo('/home');
    }
  }

  // Is Page part of the Rollout Plan?
  if (userStore.user && to.meta.permittedPlan) {
    if (!to.params?.rolloutIdentifier) {
      return navigateTo('/home');
    }
    const currentRollout = userStore.availableRollouts.find(
      (rollout) => rollout.identifier === to.params?.rolloutIdentifier
    );
    if (
      !currentRollout ||
      (currentRollout.plan as number) < (to.meta.permittedPlan as number)
    ) {
      return navigateTo('/home');
    }
  }

  if (!userStore.user && to.name !== 'index') {
    return navigateTo({ path: '/', query: from.query });
  }
});
